import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { ContractorSearchInterfacePropsType } from '../..';
import { CrownSvg } from './assets/Crown.svg';
import { KEYWORD_LIST } from './consts/keywordList';

const { tablet, mobile } = mediaQueries();

const KEY_NAME = 'SearchByKeyword';
const PARAM_NAME = 'preferredSearchKeyword';

export type SearchByReviewPropsType = Merge<ContractorSearchInterfacePropsType & {
  onApplyHandler: () => void;
}>;

export const SearchByKeyword = (props: SearchByReviewPropsType) => {
  const { userAnswers, commonAnswerHandler, onApplyHandler: onApplyHandlerFromProps } = props;
  const onApplyHandler = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    const { textContent } = event.currentTarget;
    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: 'searchByKeyword',
      paramName: PARAM_NAME,
      question: '業者の絞り込みキーワードは',
      answer: textContent || '',
      value: textContent || '',
    });

    onApplyHandlerFromProps();
  }, [commonAnswerHandler, onApplyHandlerFromProps, userAnswers]);

  return (
    <div
      css={css`
        background-color: #e7fbfb;
        border-radius: 20px;

        ${tablet(() => css`
          border-radius: 0;
        `)}
      `}
    >
      <div
        css={css`
          padding: 50px 80px;

          ${tablet(({ setAutomaticDesignBasedSize }) => css`
            max-width: 568px;
            margin-inline: auto;
            padding: ${setAutomaticDesignBasedSize(50, 40)} 1em;
          `)}

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            padding: ${setAutomaticDesignBasedSize(50, 40)} 0.8em;
          `)}
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 0 4px;
            margin-bottom: 30px;

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              margin-bottom: ${setAutomaticDesignBasedSize(30, 24)};
            `)}
          `}
        >
          <p
            css={css`
              color: #000;
              font-size: 20px;
              font-weight: bold;

              ${mobile(({ setAutomaticDesignBasedSize }) => css`
                font-size: ${setAutomaticDesignBasedSize(20, 17)};
              `)}
            `}
          >
            塗装業者を人気キーワードから探す
          </p>
          <div
            css={css`
              font-size: 0;
              width: 23px;
              padding-bottom: 4px;

              ${mobile(({ setAutomaticDesignBasedSize }) => css`
                width: ${setAutomaticDesignBasedSize(23, 17)};
                padding-bottom: ${setAutomaticDesignBasedSize(4, 4)};
              `)}
            `}
          >
            <CrownSvg />
          </div>
        </div>
        <div
          css={css`
            display: flex;
            gap: 25px 10px;
            flex-wrap: wrap;

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              gap: ${setAutomaticDesignBasedSize(25, 15)} ${setAutomaticDesignBasedSize(10, 10)};
            `)}
          `}
        >
          {KEYWORD_LIST.map((keyword, index) => {
            return (
              <button
                key={index}
                value={keyword}
                onClick={onApplyHandler}
                id={`ga_event_${KEY_NAME}_button_${index + 1}`}
                css={css`
                  color: #272343;
                  font-size: 16px;
                  font-weight: bold;
                  text-align: center;
                  width: fit-content;
                  min-width: 5em;
                  padding: 13px 26px;
                  background-color: #fff;
                  border-radius: 24px;

                  ${mobile(({ setAutomaticDesignBasedSize }) => css`
                    font-size: ${setAutomaticDesignBasedSize(16, 14)};
                    padding: ${setAutomaticDesignBasedSize(13, 9)} ${setAutomaticDesignBasedSize(26, 15)};
                  `)}

                  &:hover {
                    background-color: #ffd803;
                  }
                `}
              >
                {keyword}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
